import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

export const CardSubTitle = ({ className, muted, ...props }) => (
    <h6
        className={classNames("card-subtitle", className, {
            "text-muted": muted,
        })}
        {...props}
    >
        {props.children}
    </h6>
);
